<!-- BaseInput.vue (admin) -->
<template tag="관리자 인풋 컴포넌트">
  <v-textarea
    v-if="textarea"
    ref="baseInput"
    v-bind="$attrs"
    :hideDetails="hideDetails"
    :class="{ input_error: error, border_none: border_none }"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    v-model="model"
    :rows="rows"
  ></v-textarea>
  <v-text-field
    v-else
    ref="baseInput"
    v-bind="$attrs"
    :hideDetails="hideDetails"
    :type="type"
    :class="{ input_error: error, border_none: border_none }"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    autocomplete="off"
    v-model="model"
  ></v-text-field>
</template>

<script setup lang="ts">
import { ref } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string | number | null>({ required: true, default: null });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  placeholder: {
    type: String,
    default: "", // placeholder 값
  },
  type: {
    type: String,
    default: "text", // 기본값을 "text"로 설정
  },
  textarea: {
    type: Boolean,
    default: false, // textarea 여부
  },
  rows: {
    type: Number,
    default: 3, // textarea 기본 행 수
  },
  error: {
    type: Boolean,
    default: false, // 에러 여부
  },
  errorText: {
    type: String,
    default: "", // 에러 메시지
  },
  disabled: {
    type: Boolean,
    default: false, // 비활성화 여부
  },
  readonly: {
    type: Boolean,
    default: false, // 읽기 전용 여부
  },
  border_none: {
    type: Boolean,
    default: false, // border_none 필요할 떈 true로 변경
  },
  hideDetails: {
    type: Boolean,
    default: true, // 상세 정보 숨기기 여부
  },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
const baseInput = ref<HTMLInputElement>();

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 포커스 처리 */
const focus = () => {
  baseInput.value?.focus();
};

/* ------------------------------------------------------------
                          Expose
   ------------------------------------------------------------ */
defineExpose({
  focus,
});
</script>
